import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { api } from '@onvice/portal-shell-api';

/**
 * Mobile-Homepage-Index: redirected zur ersten konfigurierten Tab (= Modul-Root).
 * Auf Desktop ist die Sicht nicht gedacht → Picker. Mobile-User landen hier
 * nach Login.
 */
export default function MobileHomeIndex() {
  const navigate = useNavigate();
  useEffect(() => {
    const isNarrow = typeof window !== 'undefined' && window.innerWidth < 768;
    if (!isNarrow) {
      navigate('/', { replace: true });
      return;
    }
    api
      .get<{ success: boolean; data: { tabs: Array<{ slug: string; route: string }> } }>('/portal/home-mobile/tabs')
      .then((res) => {
        const first = res.data?.tabs?.[0];
        if (first?.route) navigate(first.route, { replace: true });
        else navigate('/', { replace: true });
      })
      .catch(() => navigate('/', { replace: true }));
  }, [navigate]);

  return (
    <div className="flex items-center justify-center py-20">
      <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
    </div>
  );
}
